<template lang="pug">
    .related_article(v-if="relatedArticleList.length > 0")
        .related_article_inner
            .related_article_title
                span._en RECOMMEND!
                span._jp 関連記事
            ul.related_article_card_list
                li.card(v-for="(article, index) in relatedArticleList")
                    template(v-if="article")
                        .card_link
                            public-related-article-card(:article="article")
</template>

<script>
import PublicRelatedArticleCard from '@/components/PublicRelatedArticleCard.vue'

export default {
    name: 'PublicRelatedArticleCardList',
    components: {
        PublicRelatedArticleCard
    },
    props: [
        'relatedArticleList',
    ],
    computed: {
        showParentCategory() {
            return this.article.category
        },
        showDate() {
            return ['news', 'articles'].includes(this.article.category.slug)
        }
    },
}
</script>